import React, { useState } from 'react';
import { useRequest } from 'ahooks';
import { getAnswer, checkAnswer } from '../service/theme';
import { Toast } from 'antd-mobile';
import useAppService from '../useAppService';

export default function useAnswer(record) {

    const [answerStatus, setanswerStatus] = useState(null);

    const { runTheme, runGetUserInfo } = useAppService(false);

    // answerIndex : ABCD 选择的序号
    // index : 当前题目序号
    const { loading, run: runExam } = useRequest(({ first, knowledgeId, testId, answer }, answerIndex , index) => getAnswer({
        first,
        knowledgeId,
        testId,
        answer,
    }), {
        manual: true,
        onSuccess: (result, params) => {
            if (result.status) {
                // console.log(result)
                if (result.data === 'Y') {
                    document.querySelectorAll('.answer')[params[1]].className = document.querySelectorAll('.answer')[params[1]].className + ' right';
                    record.current[params[2]] = true
                } else {
                    document.querySelectorAll('.answer')[params[1]].className = document.querySelectorAll('.answer')[params[1]].className + ' error';
                    record.current[params[2]] = true
                }
            }
        },
        onError: (error, params) => {
            Toast.show({
                content: '出错了',
            })
            record.current[params[2]] = false
        },
    });

    const { run: runCheckAnswer } = useRequest(params => checkAnswer(params), {
        manual: true,
        onSuccess: (res, param) => {
            if (res.status) {
                setanswerStatus(res.data)
                runTheme()
                runGetUserInfo()
            }
        }
    })

    return {
        answerStatus,
        setanswerStatus,
        runExam,
        runCheckAnswer
    }

}
